import React from 'react';
import styles from './MakePaymentHeading.module.scss';

interface Props {
  Header: string;
  HeaderText: string;
}

const MakePaymentHeading = ({ Header, HeaderText }: Props) => {
  return (
    <>
      <div className={styles.heading_wrapper}>
        <div className={styles.paymentwrapper_heading}>
          <h1 className={styles.heading}>
            {Header}
            <span className={styles.Text_large}>{HeaderText}</span>
          </h1>
          <div className={styles.logowrapper}>
            <img
              src={process.env.PUBLIC_URL + '/images/icons/SecurePayment.svg'}
              width="31"
              height="37"
            />
            <span className={styles.logotext}>
              Secure
              <br />
              Payment
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default MakePaymentHeading;
